<template>
  <div class="tab-content">
    <div class="tab-pane fade show active">
      <div v-if="hasDummyprocessedData" class="subscribe-container text-center">
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="processedData"
        border
        class="custom-scrollable-table header-color"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/passive.svg"
                alt="Active"
                class="header-icon"
              />
              Moderate - <span style="color: #ffff9e">Active</span> &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Moderate', content1)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>

              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistProcessedData"
          :class="{ 'no-sort-icon': isTrialExistProcessedData }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistProcessedData"
          :class="{ 'no-sort-icon': isTrialExistProcessedData }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistProcessedData"
          :class="{ 'no-sort-icon': isTrialExistProcessedData }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistProcessedData"
          :class="{ 'no-sort-icon': isTrialExistProcessedData }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
          style="border-bottom: none !important"
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
              popper-class="custom-tooltip"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyindexModerateFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="indexModerateFundsProcessed"
        border
        style="width: 100%"
        :row-class-name="getRowClassName"
        class="custom-scrollable-table header-color"
        :default-sort="defaultSort"
        scrollbar-always-on
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/passive.svg"
                alt="Active"
                class="header-icon"
              />
              Moderate - <span style="color: #1fd19f">Passive</span> &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Moderate', content1)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistIndexModerateFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexModerateFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistIndexModerateFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexModerateFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistIndexModerateFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexModerateFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistIndexModerateFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexModerateFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyaggressiveFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="aggressiveFundsProcessed"
        border
        style="width: 100%"
        class="custom-scrollable-table header-aggressive"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/active.svg"
                alt="Active"
                class="header-icon"
              />
              Aggressive - <span style="color: #ffff9e">Active</span> &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Aggressive', content2)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistAgressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistAgressiveFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistAgressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistAgressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistAgressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistAgressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistAgressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistAgressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyindexAggressiveFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="indexAggressiveFundsProcessed"
        border
        style="width: 100%"
        class="custom-scrollable-table header-aggressive"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/active.svg"
                alt="Active"
                class="header-icon"
              />
              Aggressive -
              <span style="color: #1fd19f">Passive</span> &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Equity - Aggressive', content2)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistIndexAggressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexAggressiveFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistIndexAggressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexAggressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistIndexAggressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexAggressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistIndexAggressiveFunds"
          :class="{ 'no-sort-icon': isTrialExistIndexAggressiveFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyturnAroundProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="turnAroundProcessed"
        border
        class="custom-scrollable-table header-aggressive"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin-top: 5px">
              <img
                src="@/assets/images/active.svg"
                alt="Active"
                class="header-icon"
              />
              High-risk turnarounds &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('High-risk turnarounds', content3)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>

              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistTurnAroundFunds"
          :class="{ 'no-sort-icon': isTrialExistTurnAroundFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistTurnAroundFunds"
          :class="{ 'no-sort-icon': isTrialExistTurnAroundFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistTurnAroundFunds"
          :class="{ 'no-sort-icon': isTrialExistTurnAroundFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistTurnAroundFunds"
          :class="{ 'no-sort-icon': isTrialExistTurnAroundFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
          style="border-bottom: none !important"
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span style="border-bottom: none !important">{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        v-model="isDialogVisible"
        class="fw-bold dialog-color"
        :title="dialogTitle"
        :width="popupwidth"
      >
        <p>{{ dialogContent }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false" class="v-btn btn-color"
            >Close</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        v-model="isCommentPopupVisible"
        :width="popupwidth"
        class="dialog-color"
      >
        <template #title>
          <div class="fw-bold">
            <h3>{{ selectedFund.name }}</h3>
          </div>
        </template>
        <p class="fw-bold">Research report</p>
        <hr />
        <div v-html="selectedFund.comment"></div>
        <div class="d-flex justify-content-center">
          <el-button
            @click="isCommentPopupVisible = false"
            class="v-btn btn-color"
          >
            Close
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const store = useStore();
const popup = require("@/assets/images/helpcircle.svg");
const baseUrl = process.env.VUE_APP_BASE_URL;
const eyeAdd = require("@/assets/images/eyeAdd.svg");
const eye = require("@/assets/images/eye.svg");
const eyeRemove = require("@/assets/images/eyeRemove.svg");
const isSmallScreen = ref(false);
const columnWidth = computed(() => (isSmallScreen.value ? 270 : 350));
const popupwidth = computed(() => (isSmallScreen.value ? "100%" : "50%"));
const aggressiveFunds = computed(() => store.getters.getAggressiveFunds);
const indexAggressiveFunds = computed(
  () => store.getters.getIndexAggressiveFunds
);
const indexModerateFunds = computed(() => store.getters.getIndexModerateFunds);
const moderateFunds = computed(() => store.getters.getModerateFunds);
const turnAroundFunds = computed(() => store.getters.getTurnaroundFunds);
function onSubscribeClick() {
  const baseUrl = process.env.VUE_APP_BASE_URL;
  const subscriptionUrl = `${baseUrl}/prime-pricing`;
  window.open(subscriptionUrl, "_blank");
}
const checkTrialExists = (data) => {
  return data.some((row) => row.trial === "1");
};

const isTrialExistProcessedData = computed(() =>
  checkTrialExists(processedData.value)
);

const isTrialExistIndexModerateFunds = computed(() =>
  checkTrialExists(indexModerateFunds.value)
);

const isTrialExistAgressiveFunds = computed(() =>
  checkTrialExists(aggressiveFunds.value)
);
const isTrialExistIndexAggressiveFunds = computed(() =>
  checkTrialExists(indexAggressiveFunds.value)
);
const isTrialExistTurnAroundFunds = computed(() =>
  checkTrialExists(turnAroundFunds.value)
);
const getRowClassName = (row) => {
  const isDummy = row.row.isDummy === true;
  return isDummy ? "blur-row" : "";
};

const processData = (data) => {
  if (!Array.isArray(data)) {
    console.error("Data is not an array:", data);
    return [];
  }
  const actualData = data.map((row) => ({
    ...row,
    isDummy: false,
  }));
  const trialExists = actualData.some((row) => row.trial === "1");
  if (trialExists) {
    const dummyRows = actualData.slice(0, 2).map((row) => ({
      ...row,
      isDummy: true,
    }));
    const repeatedDummyRows = [...dummyRows, ...dummyRows];
    return [...actualData, ...repeatedDummyRows];
  }
  return actualData.sort(
    (a, b) => (b.fiveYearCAGR || 0) - (a.fiveYearCAGR || 0)
  );
};
const hasDummyprocessedData = computed(() => {
  return processedData.value.some((row) => row.isDummy);
});

const hasDummyaggressiveFundsProcessed = computed(() => {
  return aggressiveFundsProcessed.value.some((row) => row.isDummy);
});

const hasDummyindexAggressiveFundsProcessed = computed(() => {
  return indexAggressiveFundsProcessed.value.some((row) => row.isDummy);
});

const hasDummyindexModerateFundsProcessed = computed(() => {
  return indexModerateFundsProcessed.value.some((row) => row.isDummy);
});

const hasDummyturnAroundProcessed = computed(() => {
  return turnAroundProcessed.value.some((row) => row.isDummy);
});

const processedData = computed(() => {
  return processData(moderateFunds.value);
});

const aggressiveFundsProcessed = computed(() => {
  return processData(aggressiveFunds.value);
});

const indexAggressiveFundsProcessed = computed(() => {
  return processData(indexAggressiveFunds.value);
});

const indexModerateFundsProcessed = computed(() => {
  return processData(indexModerateFunds.value);
});

const turnAroundProcessed = computed(() => {
  return processData(turnAroundFunds.value);
});
const checkScreenSize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};
function sortByProperty(rowA, rowB, property) {
  const numA = parseFloat(rowA[property]);
  const numB = parseFloat(rowB[property]);

  if (isNaN(numA)) return 1;
  if (isNaN(numB)) return -1;

  return numA - numB;
}
onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreenSize);
});

const isDialogVisible = ref(false);
const dialogContent = ref("");
const dialogTitle = ref("");
const content1 = `These funds hold a majority of their portfolio in large-cap stocks. They suit all equity investors. Hold these funds for not less than 5 years`;
const content2 = `These funds have an aggressive strategy with a moderate to high share of mid and small-cap stocks. They carry a higher risk of short-to-medium-term losses and are volatile. Hold these funds for at least 5 years and restrict their total exposure in your equity portfolio to a third or less`;
const content3 = `Funds that have seen a performance turnaround or are tactical plays in a given market phase. They may often be from small AMCs with low AUMs. Keep allocation to these at under 5% of your portfolio. We may give an exit call on these funds at any point if risk outweighs returns or if the fund is unable to sustain performance`;

const openDialog = (title, content) => {
  dialogTitle.value = title;
  dialogContent.value = content;
  isDialogVisible.value = true;
};

onMounted(() => {
  store.dispatch("fetchFunds");
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
});
const toggleWatchlist = async (fund) => {
  fund.statusMessage = "";
  fund.showStatusMsg = true;
  let success;
  if (Number(fund.inWatchlist) === 1) {
    fund.statusMessage = "Removing from Watchlist...";
    success = await store.dispatch("removemffromwatchlist", fund.schemeCode);
    if (success === true) {
      fund.inWatchlist = 0;
      fund.statusMessage = "Removed from Watchlist";
    } else {
      alert("Failed to remove from watchlist. Please try again.");
      fund.showStatusMsg = false;
    }
  } else {
    fund.statusMessage = "Adding to Watchlist...";
    success = await store.dispatch("saveMfWatchlist", fund.schemeCode);
    if (success === true) {
      fund.inWatchlist = 1;
      fund.statusMessage = "Added to Watchlist";
    } else {
      alert("Failed to add to watchlist. Please try again.");
      fund.showStatusMsg = false;
    }
  }
  setTimeout(() => {
    fund.showStatusMsg = false;
  }, 1000);
};
const selectedFund = ref({
  name: "",
  category: "",
  comment: "",
});
const isCommentPopupVisible = ref(false);
const showCommentPopup = (fund) => {
  isCommentPopupVisible.value = true;
  selectedFund.value.name = fund.name;
  selectedFund.value.category = fund.category;
  selectedFund.value.comment = fund.comment;
};
</script>

<style scoped>
.subscribe-container {
  z-index: 5;
  position: relative;
  top: 240px;
  margin-bottom: -35px;
  margin-top: -6%;
}

@media (max-width: 1199px) {
  .subscribe-container {
    top: 325px;
    margin-top: -8%;
  }
}

@media (min-width: 555px) and (max-width: 991px) {
  .subscribe-container {
    top: 325px;
    margin-top: -11%;
  }
}

@media (min-width: 450px) and (max-width: 554px) {
  .subscribe-container {
    top: 325px;
    margin-top: -18%;
  }
}

@media (max-width: 450px) {
  .subscribe-container {
    top: 325px;
    margin-top: -24%;
  }
}

.locked-message {
  display: block;
  font-size: 16px;
  margin-bottom: 12px;
  color: #333;
}

.prime-funds {
  position: relative;
}

.fund-name {
  color: #00a3d9;
  font-weight: 600;
}

::v-deep(.el-table .descending .sort-caret.descending) {
  border-top-color: white !important;
}

::v-deep(.el-table .ascending .sort-caret.ascending) {
  border-bottom-color: white !important;
}

.funds-popup {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  cursor: pointer;
}

.header-color {
  --el-table-header-bg-color: #0377a6;
}
.header-aggressive {
  --el-table-header-bg-color: #012e40;
}

.new-tag {
  position: absolute;
  top: -6px;
  left: -19px;
  background-color: red;
  color: white;
  font-size: 8px;
  padding: 2px 18px 0px 18px;
  z-index: 10;
  font-weight: bold;
  transform: rotate(-45deg);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
}

.watchlist-icon {
  cursor: pointer;
}

.btn-color {
  background: #00a3d9 !important;
  border-radius: 10px;
  color: white !important;
  padding: 20px;
}

.gap-data {
  column-gap: 5px;
  padding: 10px;
  padding-left: 19px;
}

.watchlist-container td:first-child {
  position: relative;
}

.watchlist-status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  pointer-events: none;
  background: linear-gradient(90deg, #012e40 0%, #ffffff 100%);
  padding: 13px !important;
}

.watchlist-status-message {
  font-size: 14px;
  color: white !important;
}

.watchlist-status-image {
  width: 100%;
  height: auto;
  background: linear-gradient(90deg, #012e40 0%, #ffffff 100%);
}

.header-icon {
  width: 45px;
  height: 40px;
  margin-bottom: 7px;
}

.custom-scrollable-table {
  --el-table-header-text-color: white;
  --el-table-header-font-weight: bold;
  --el-table-border-color: none;
  border: 1px solid black;
  position: relative;
  overflow: hidden;
  border-collapse: collapse;
}

@media (min-width: 769px) {
  .custom-scrollable-table {
    border-radius: 10px;
  }
}

::v-deep(.el-table .el-table__cell),
::v-deep(.el-table .cell) {
  padding: 0px !important;
}

::v-deep(.custom-scrollable-table tbody tr:last-child td) {
  border-bottom: none;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th) {
  font-size: larger;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td) {
  text-align: center !important;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper th:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:last-child) {
  text-align: left !important;
}

::v-deep(.custom-scrollable-table tbody tr td) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
  margin: 10px !important;
}

::v-deep(.custom-scrollable-table thead tr th) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
}

::v-deep(.custom-scrollable-table thead tr th:last-child),
::v-deep(.custom-scrollable-table tbody tr td:last-child) {
  border-right: none;
}

@media (max-width: 768px) {
  ::v-deep(.custom-scrollable-table thead tr th:first-child),
  ::v-deep(.custom-scrollable-table tbody tr td:first-child) {
    filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
  }
}

::v-deep(.el-table__body, .el-table__footer) {
  margin: 0 !important;
}

::v-deep(.el-table__header),
::v-deep(.el-table__body) {
  margin: 0 !important;
  width: 100% !important;
}

::v-deep(.dialog-color .el-dialog__header .el-dialog__headerbtn) {
  background: white !important;
}

::v-deep .blur-row {
  filter: blur(9px) !important;
}
</style>
